function getDiscountCodeForReferral(referral) {
  var mapping = {
    "register-qr-gds": "BENVENUTOCAFFE",
    "register-qr-amazon": "BENVENUTOCAFFE",
    "register-qr-amazonreal": "BENVENUTOCAFFE",
    "register-thun": "BENVENUTOCAFFE",
    "register-milano": "MILANOM",
    "register-stramilano2025": "Registrazione-Stramilano-2025"
  };
  return mapping[referral];
}

function getFreeProductForReferral(referral) {
  var mapping = {
    "register-stramilano2025": "51004950184263"
  };
  return mapping[referral];
}

function applyDiscount(discountCode) {
  // Send GET request to "/discount/[discountcode]"
  fetch(`/discount/${discountCode}`)
    .then(function () {
      console.log("[DISCOUNT] sconto applicato");
      // Save the discount code as a session cookie
      document.cookie = `discount_code=${discountCode}; path=/`;
      sessionStorage.setItem('applied-discount', discountCode);
      // After the discount code has been applied, force the cart to update so the discount is visible instantly
      reloadCart();
    })
    .catch(function (error) {
      console.log("[DISCOUNT] errore nello sconto: " + error);
    });
}

function getAppliedDiscount() {
  return sessionStorage.getItem('applied-discount');
}

function reloadCart() {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: {},
    }),
  });
}

function addToCart(variantId, quantity, onSuccess, onError) {
  let formData = {
    'items': [{
     'id': variantId,
     'quantity': quantity
     }]
   };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`Unable to add product to cart (${response.status})`);
    }
    onSuccess(response);
  })
  .catch((error) => {
    onError(error);
  });
}
